import { useState } from 'react';
import type { FaqItem } from '@/types/feed';

interface FaqAccordionProps {
  items: FaqItem[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <div className="divide-y divide-background-200/70 overflow-hidden rounded-lg border border-background-200/70 bg-background-100/60">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div key={item.q}>
            <button
              type="button"
              onClick={() => setOpenIndex(open ? -1 : index)}
              aria-expanded={open}
              className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 md:px-6 md:py-5"
            >
              <span className="flex items-start gap-3">
                <span className="mt-0.5 font-label text-xs text-accent-400 tabular-nums">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                  {item.q}
                </span>
              </span>
              <i
                className={`shrink-0 text-lg text-foreground-600 transition-transform duration-300 ${
                  open ? 'rotate-45' : ''
                } ri-add-line`}
              />
            </button>
            <div
              className={`grid overflow-hidden transition-all duration-300 ${
                open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-4 pb-5 pl-11 text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-[60px]">
                  {item.a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}